import {
  Box,
  Button,
  Flex,
  HStack,
  Image,
  Link,
  Text,
  useBreakpointValue,
} from "@chakra-ui/react";
// import {
//   FaChalkboardTeacher,
//   FaChurch,
//   FaPhoneAlt,
//   FaUserAlt,
// } from "react-icons/fa";
import maleBuilder from "../img/male-builder.png";
import registrationService from "../services/registration.service";
import { FiDownload } from "react-icons/fi";

import documentViewer from "../img/arcticons_document-viewerVector.svg";
import highVoltage from "../img/high-voltage.png";
import gear from "../img/searchGearVector.svg";
import calender from "../img/trainingCalenderVector.svg";
import center from "../img/trainingCenterVector.svg";
import upcoming from "../img/upcomingVector.svg";
import femaleEngineer from "../img/young-female-engineer.svg";

import { useEffect, useState } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { useNavigate } from "react-router-dom";
import { IAllCourse } from "../models/allcourse.model";
import courseRoutes from "../pages/courses/courseRoutes";
import routes from "../pages/routes";
import CenterService from "../services/admin/center.service";
import Footer from "./common/Footer";
import Header from "./common/Header";
import Loading from "./common/Loading";
import SafeSecure from "./common/SafeSecure";
import { TCalendar } from "../models/calendar-model";

const LandingPage = () => {
  const navigate = useNavigate();
  const [allCourses, setAllCourses] = useState<IAllCourse[]>([]);
  const [loading, setLoading] = useState(true);
  const [imagefile, setImageFile] = useState<TCalendar>();
  const isMobile = useBreakpointValue({ base: true, lg: false });

  useEffect(() => {
    getAllCentres();
    registrationService.getAllCourses().then((res) => {
      const courses: any = res; // remove data
      if (courses?.length > 0) {
        setAllCourses(courses?.slice(0, 2));
      } else {
        setAllCourses([]);
      }
      setLoading(false);
    });
    registrationService.downloadTrainingCalendar().then((response) => {
      setImageFile(response.data);
    });
  }, []);

  const handleDownload = () => {
    if (imagefile && imagefile.attachment) {
      fetch(imagefile.attachment)
        .then((response) => response.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;

          // Determine the file extension based on the MIME type
          const extension = blob.type.split("/")[1];
          const fileName = `${imagefile.calendar_name}.${extension}`;

          link.setAttribute("download", fileName); // Set the file name with extension
          document.body.appendChild(link);
          link.click();
          if (link.parentNode) {
            link.parentNode.removeChild(link);
          } else {
            document.body.removeChild(link); // Fallback if link.parentNode is null
          }
        })
        .catch((error) => console.error("Error downloading the image:", error));
    }
  };

  const getAllCentres = async () => {
    const response = await CenterService.getCenters("?category=rtc");
  };

  const viewCourse = async (course_id: string) => {
    navigate(courseRoutes.ViewLink(course_id));
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Box>
          <Header />

          <Box position="relative" mb="100px">
            <Box px={[0, 0, 12, 12]} mt="12px">
              <Carousel
                autoPlay={true}
                showThumbs={false}
                interval={6000}
                infiniteLoop={true}
              >
                <Flex
                  alignItems="center"
                  width="100%"
                  className="filter"
                  backgroundSize="cover"
                  backgroundRepeat="no-repeat"
                  height={["500px", "500px", "600pxpx", "705px"]}
                >
                  <Box>
                    <Text
                      ml={["40px", "40px", "100px", "135px"]}
                      fontSize={["35px", "60px", "68px", "68px"]}
                      color="white"
                      fontWeight="700"
                      textAlign="left"
                    >
                      Welcome to{" "}
                    </Text>
                    <Text
                      ml={["40px", "40px", "100px", "135px"]}
                      fontSize={["35px", "60px", "68px", "68px"]}
                      color="white"
                      fontWeight="700"
                      textAlign="left"
                      mt="-15px"
                    >
                      NAPTIN TMIS
                    </Text>

                    <Text
                      mt="-10px"
                      fontSize={["18px", "18px", "24px", "24px"]}
                      ml={["40px", "40px", "100px", "135px"]}
                      textAlign="left"
                      fontWeight="400"
                      color="white"
                    >
                      {" "}
                      Training Management Information System
                    </Text>
                    <Text
                      textAlign="left"
                      ml={["40px", "40px", "100px", "135px"]}
                    >
                      <Button
                        py="13px"
                        px="30px"
                        onClick={() => navigate(courseRoutes.AllCourses)}
                        mt="30px"
                        borderRadius={0}
                        colorScheme="red"
                        size="sm"
                      >
                        TAKE COURSES
                      </Button>
                    </Text>
                  </Box>
                </Flex>
                <Flex
                  alignItems="center"
                  width="100%"
                  className="filter2"
                  backgroundSize="cover"
                  backgroundRepeat="no-repeat"
                  height={["500px", "500px", "600pxpx", "705px"]}
                >
                  <Box>
                    <Text
                      ml={["40px", "40px", "100px", "135px"]}
                      fontSize={["35px", "60px", "68px", "68px"]}
                      color="white"
                      fontWeight="700"
                      textAlign="left"
                    >
                      Welcome to{" "}
                    </Text>
                    <Text
                      ml={["40px", "40px", "100px", "135px"]}
                      fontSize={["35px", "60px", "68px", "68px"]}
                      color="white"
                      fontWeight="700"
                      textAlign="left"
                      mt="-15px"
                    >
                      NAPTIN TMIS
                    </Text>

                    <Text
                      mt="-10px"
                      fontSize={["18px", "18px", "24px", "24px"]}
                      ml={["40px", "40px", "100px", "135px"]}
                      textAlign="left"
                      fontWeight="400"
                      color="white"
                    >
                      {" "}
                      Training Management Information System
                    </Text>
                    <Text
                      textAlign="left"
                      ml={["40px", "40px", "100px", "135px"]}
                    >
                      <Button
                        py="13px"
                        px="30px"
                        onClick={() => navigate(courseRoutes.AllCourses)}
                        mt="30px"
                        borderRadius={0}
                        colorScheme="red"
                        size="sm"
                      >
                        TAKE COURSES
                      </Button>
                    </Text>
                  </Box>
                </Flex>
                <Flex
                  alignItems="center"
                  width="100%"
                  className="filter3"
                  backgroundSize="cover"
                  backgroundRepeat="no-repeat"
                  height={["500px", "500px", "600pxpx", "705px"]}
                >
                  <Box>
                    <Text
                      ml={["40px", "40px", "100px", "135px"]}
                      fontSize={["35px", "60px", "68px", "68px"]}
                      color="white"
                      fontWeight="700"
                      textAlign="left"
                    >
                      Welcome to{" "}
                    </Text>
                    <Text
                      ml={["40px", "40px", "100px", "135px"]}
                      fontSize={["35px", "60px", "68px", "68px"]}
                      color="white"
                      fontWeight="700"
                      textAlign="left"
                      mt="-15px"
                    >
                      NAPTIN TMIS
                    </Text>

                    <Text
                      mt="-10px"
                      fontSize={["18px", "18px", "24px", "24px"]}
                      ml={["40px", "40px", "100px", "135px"]}
                      textAlign="left"
                      fontWeight="400"
                      color="white"
                    >
                      {" "}
                      Training Management Information System
                    </Text>
                    <Text
                      textAlign="left"
                      ml={["40px", "40px", "100px", "135px"]}
                    >
                      <Button
                        py="13px"
                        px="30px"
                        onClick={() => navigate(courseRoutes.AllCourses)}
                        mt="30px"
                        borderRadius={0}
                        colorScheme="red"
                        size="sm"
                      >
                        TAKE COURSES
                      </Button>
                    </Text>
                  </Box>
                </Flex>
              </Carousel>
            </Box>

            <Flex justifyContent="center" width="100%" backgroundColor="red">
              <Box
                width={["95%", "90%", "80%", "80%"]}
                position="absolute"
                mx="auto"
                mt="-65px"
                px={["20px", "20px", "40px", "40px"]}
                py="20px"
                bg="white"
                className="zind"
                zIndex="2"
                mb="40px"
                boxShadow={"0px 4px 9px 0px #33313117"}
                boxSizing="border-box"
              >
                <Text
                  ml={["20px", "20px", "0px", "0px"]}
                  mb="5px"
                  fontSize={"14px"}
                >
                  QUICK LINKS
                </Text>
                <Flex
                  justifyContent="space-between"
                  gap="1rem"
                  overflowX={"scroll"}
                  className="scroll-hidden"
                >
                  <HStack>
                    <Flex
                      width={["30px", "30px", "45px", "45px"]}
                      height={["30px", "30px", "45px", "45px"]}
                      bg="#FFF0F0"
                      borderRadius="5px"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Image src={upcoming} alt="" />
                    </Flex>

                    <Text
                      fontWeight="600"
                      fontSize={["12px", "13px", "15px", "15px"]}
                    >
                      <Link onClick={() => navigate(routes.UpcomingTraining)}>
                        Upcoming <br></br>
                        Trainings
                      </Link>
                    </Text>
                  </HStack>
                  <HStack cursor="pointer">
                    <Flex
                      width={["30px", "30px", "45px", "45px"]}
                      height={["30px", "30px", "45px", "45px"]}
                      bg="#FFF0F0"
                      borderRadius="5px"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Image src={documentViewer} alt="" />
                    </Flex>
                    <Text
                      fontWeight="600"
                      fontSize={["12px", "13px", "15px", "15px"]}
                    >
                      <Link onClick={() => navigate(courseRoutes.AllCourses)}>
                        Programs & {isMobile ? "" : <br></br>}
                        Courses
                      </Link>
                    </Text>
                  </HStack>
                  <HStack>
                    <Flex
                      width={["30px", "30px", "45px", "45px"]}
                      height={["30px", "30px", "45px", "45px"]}
                      bg="#FFF0F0"
                      borderRadius="5px"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Image src={center} alt="" />
                    </Flex>
                    <Text
                      fontWeight="600"
                      fontSize={["12px", "13px", "15px", "15px"]}
                    >
                      <Link onClick={() => navigate(routes.TrainingCenters)}>
                        Training <br></br>
                        Centers
                      </Link>
                    </Text>
                  </HStack>
                  <HStack>
                    <Flex
                      width={["30px", "30px", "45px", "45px"]}
                      height={["30px", "30px", "45px", "45px"]}
                      bg="#FFF0F0"
                      borderRadius="5px"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Image src={gear} alt="" />
                    </Flex>
                    <Text
                      fontWeight="600"
                      fontSize={["12px", "13px", "15px", "15px"]}
                    >
                      <Link onClick={() => navigate(routes.TrackApplication)}>
                        Track your <br></br>
                        enrollment
                      </Link>
                    </Text>
                  </HStack>
                  <HStack>
                    <Flex
                      width={["30px", "30px", "45px", "45px"]}
                      height={["30px", "30px", "45px", "45px"]}
                      bg="#FFF0F0"
                      borderRadius="5px"
                      justifyContent="center"
                      alignItems="center"
                    >
                        <FiDownload color="#EC3337" fontSize={"22px"} fontWeight={"600"}/>
                    </Flex>
                    <Text
                      fontWeight="600"
                      fontSize={["12px", "13px", "15px", "15px"]}
                    >
                      <Link onClick={handleDownload}>
                        Training <br></br>
                        Calender
                      </Link>
                    </Text>
                  </HStack>
                </Flex>
              </Box>
            </Flex>
          </Box>

          <Flex
            alignItems="center"
            flexDirection={["column", "column", "row", "row"]}
            justifyContent="space-between"
            pt={["10px", "10px", "50px", "50px"]}
          >
            <Box
              ml={["0px", "0px", "35px", "79px"]}
              pb={["10px", "10px", "0px", "0px"]}
              px={["10px", "10px", "0px", "0px"]}
              width={["100%", "100%", "38%", "38%"]}
              flexWrap={"wrap"}
              display={"flex"}
              flexDirection={"column"}
            >
              <Text
                fontSize="42px"
                fontWeight="600"
                mb={["10px", "10px", "30px", "30px"]}
              >
                Explore Courses
              </Text>
              <Text
                // width={["100%", "100%", "350px", "437px"]}
                // height={["100%", "100%", "160px", "160px"]}
                width={["100%", "100%", "80%", "80%"]}
                fontSize={["14px", "14px", "16px", "18px"]}
                fontWeight="400"
                color="#616161"
                textAlign={"left"}
                wordBreak={"break-word"}
              >
                NAPTIN provides training on the following under-listed courses.
                The running of these courses are directly on your portal. Some
                of the courses are provided in specific centre(s) depending on
                where the facilities required for the training are available.
              </Text>
              <Button
                mt="1rem"
                height={38}
                colorScheme="red"
                size="sm"
                borderRadius={0}
                onClick={() => navigate(courseRoutes.AllCourses)}
                width={"-webkit-fit-content"}
              >
                SEE MORE
              </Button>
            </Box>
            <Flex
              width={["100%", "100%", "52%", "52%"]}
              justifyContent="space-around"
              flexDirection={["column", "column", "row", "row"]}
              gap="1rem"
            >
              {allCourses.map((each) => (
                <Box
                  key={each.id}
                  width={["100%", "100%", "45%", "45%"]}
                  boxShadow="0px 3.50207px 7.87967px rgba(51, 49, 49, 0.09)"
                >
                  <Image
                    objectFit="fill"
                    backgroundSize={"cover"}
                    src={each?.cover_image ? each.cover_image : highVoltage}
                    width="100%"
                    height="200px"
                  />
                  <Box width="90%" mx="auto" mt="21px" mb="27px">
                    <Text
                      mb="15px"
                      color="#616161"
                      fontSize={["18px", "18px", "22px", "22px"]}
                      fontWeight="500"
                      textTransform={"capitalize"}
                    >
                      {each.name.slice(0, 100).toLowerCase()}
                    </Text>
                    <Text
                      mb="18px"
                      color="#9E9E9E"
                      fontSize={["12px", "12px", "14px", "14px"]}
                      fontWeight="400"
                    >
                      {each.description
                        ? `${each.description.slice(0, 200)}...`
                        : "nil"}
                    </Text>
                    <Link
                      fontWeight="500"
                      color="#EC3337"
                      fontSize={["12px", "12px", "14px", "14px"]}
                      onClick={() => viewCourse(each.uuid)}
                    >
                      View Course
                    </Link>
                  </Box>
                </Box>
              ))}
            </Flex>
          </Flex>
          <Flex
            px={["30px", "30px", "0px", "75px"]}
            flexDirection={["column", "column", "row", "row"]}
            mt="32px"
            mb={["30px", "30px", "80px", "80px"]}
            justifyContent="space-between"
            gap="2rem"
          >
            <Box>
              <Image src={femaleEngineer} />
            </Box>
            <Box
              my="auto"
              display={"flex"}
              gap="1rem"
              flexDirection={"column"}
              p="2rem 2rem 2rem 1rem"
              width={["100%", "70%", "60%", "50%"]}
            >
              <Text
                p={0}
                m="0px"
                fontSize={["24px", "24px", "32px", "36px"]}
                fontWeight="800"
                color={"#1E1E1E"}
              >
                Take Various Courses To
              </Text>
              <Text
                p={0}
                m="0px"
                fontSize={["24px", "24px", "32px", "36px"]}
                fontWeight="800"
                color={"#1E1E1E"}
              >
                {" "}
                Boost Your Career
              </Text>

              <Text
                p={0}
                m="0px"
                color="#616161"
                fontSize={["16px", "16px", "18px", "18px"]}
                fontWeight="400"
              >
                The courses are classified into technical and Non-technical
                courses. All these courses are specifically designed for
                Generation, Transmission and Distribution professionals
              </Text>

              <Button
                height={38}
                width={"-webkit-fit-content"}
                colorScheme="red"
                size="sm"
                borderRadius={0}
                onClick={() => navigate(routes.PreRegistration)}
              >
                FIND OUT HOW
              </Button>
            </Box>
          </Flex>

          <Flex
            height={["100%", "100%", "543px", "543px"]}
            mx={["0px", "0px", "40px", "49px"]}
            justifyContent="space-between"
            flexDirection={["column", "column", "row", "row"]}
            bg="#25608A"
            pt="10px"
            pb="10px"
            borderRadius={["0px", "10px", "10px", "10px"]}
            mb={["20px", "20px", "50px", "50px"]}
            color="#FFFFFF"
          >
            <Box my="auto" mx="auto" px="10px">
              <Text
                fontWeight="800"
                fontSize={["15px", "15px", "16px", "18px"]}
              >
                ABOUT US
              </Text>
              <Text
                fontWeight="400"
                mt={["15px", "15px", "28px", "28px"]}
                mb={["15px", "15px", "28px", "28px"]}
                fontSize={["15px", "15px", "18px", "22px"]}
                width={["100%", "100%", "500px", "600px"]}
              >
                The National Power Training Institute of Nigeria (NAPTIN) which
                was established on March 23rd, 2009 commenced full operation in
                September, 2009. The primary purpose for its establishment is to
                provide training for power sector personnel and coordinate
                training activities in the sector. In pursuit of this mandate,
                NAPTIN has taken over the management of existing seven regional
                training centres of PHCN.
              </Text>
              {/* <Button
                py="13px"
                px="30px"
                mt={["15px", "15px", "30px", "30px"]}
                borderRadius={0}
                colorScheme="red"
                size="sm"
              >
                READ MORE
              </Button> */}
            </Box>
            <Box display={["none", "none", "block", "block"]}>
              <Image src={maleBuilder} height="540px" />
            </Box>
          </Flex>
          <SafeSecure />

          <Footer />
        </Box>
      )}
    </>
  );
};

export default LandingPage;
